import { gql } from 'graphql-tag';

import { CountryFragments } from './CountryType';
import { RegionFragments } from './RegionType';
import { UserFragments } from './UserType';

const placeId = gql`
  fragment PlaceId on Place {
    _id: externalId
  }
`;

const nearbyPlaceNodeFields = gql`
  fragment NearbyPlaceNodeFields on Place {
    _id: externalId
    name
    slug
    latitude
    longitude
    country {
      ...CountryId
      countryName
    }
    region {
      ...RegionId
      name
    }
  }
  ${CountryFragments.id}
  ${RegionFragments.id}
`;

const placeDetailFields = gql`
  fragment PlaceDetailFields on Place {
    ...PlaceId
    name
    slug
    latitude
    longitude
    country {
      ...PlaceCountryFields
    }
    region {
      ...PlaceRegionFields
    }
  }
  ${placeId}
  ${CountryFragments.placeCountryFields}
  ${RegionFragments.placeRegionFields}
`;

const placeMetadataFields = gql`
  fragment PlaceMetadataFields on Place {
    ...PlaceId
    name
    slug
    latitude
    longitude
    country {
      ...CountryId
      countryName
    }
    region {
      ...RegionId
      regionCode
      name
      localName
    }
  }
  ${placeId}
  ${CountryFragments.id}
  ${RegionFragments.id}
`;

const placeTopAnglersFields = gql`
  fragment PlaceTopAnglersFields on TopAnglersConnection {
    totalCount
    edges {
      node {
        ...UserId
        followedByCurrentUser
        displayIcon(height: 256, width: 256) {
          width: width
          height: height
          url
        }
        displayName
        nickname
      }
    }
  }
  ${UserFragments.id}
`;

const regionPlaceNodeFields = gql`
  fragment RegionPlaceNodeFields on Place {
    ...PlaceId
    name
    slug
  }
  ${placeId}
`;

const countryPlaceNodeFields = gql`
  fragment CountryPlaceNodeFields on Place {
    ...PlaceId
    name
    slug
    latitude
    longitude
    country {
      ...CountryId
      countryName
    }
    region {
      ...RegionId
      name
    }
  }
  ${placeId}
  ${CountryFragments.id}
  ${RegionFragments.id}
`;

export const PlaceFragments = {
  id: placeId,
  carouselItem: gql`
    fragment PlaceCarouselItem on Place {
      _id: externalId
      name
      slug
      latitude
      longitude
      country {
        ...CountryId
        countryName
      }
      region {
        ...RegionId
        name
        localName
        regionCode
      }
      unsplashImage {
        id
        imageUrl
      }
    }
    ${CountryFragments.id}
    ${RegionFragments.id}
  `,
  nearbyPlaceNodeFields,
  nearestPlaceFields: gql`
    fragment NearestPlaceFields on Place {
      ...PlaceId
      latitude
      longitude
      name
      slug
      country {
        ...CountryId
        countryName
      }
      region {
        ...RegionId
        name
      }
      nearbyPlaces(first: 23) {
        edges {
          distanceUnit
          node {
            ...NearbyPlaceNodeFields
          }
        }
      }
    }
    ${placeId}
    ${CountryFragments.id}
    ${RegionFragments.id}
    ${nearbyPlaceNodeFields}
  `,
  detailFields: placeDetailFields,
  metadataFields: placeMetadataFields,
  topAnglersFields: placeTopAnglersFields,
  regionPlaceNodeFields,
  countryPlaceNodeFields,
};
